import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-20 pb-12 md:pt-28 md:pb-20 px-6 relative overflow-hidden" data-id="element-85">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-86">
        {/* Two-column layout on desktop, stacked on mobile */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-87">
          {/* Left: Text content */}
          <div className="text-center md:text-left order-1" data-id="element-88">
            <FadeIn data-id="element-89">
              <span className="inline-block py-1 px-3 rounded-full bg-sage/20 text-sage font-semibold text-sm tracking-wider uppercase mb-5" data-id="element-90">
                Para Mujeres +35
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-91">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-5 text-charcoal" data-id="element-92">
                Desinfla tu abdomen en solo 48 horas
              </h1>
            </FadeIn>

            <FadeIn delay={0.15} data-id="element-93">
              <p className="text-sm font-semibold text-terracotta tracking-wide uppercase mb-4" data-id="element-94">
                Protocolo Flash Anti-Inflamación · Reset Metabólico
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-95">
              <h2 className="text-lg md:text-xl text-charcoal/70 font-playfair italic mb-8 leading-relaxed" data-id="element-96">
                Recupera la ligereza y vuelve a cerrar tus pantalones favoritos
                antes de que suene la alarma del lunes.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} className="flex flex-col items-center md:items-start" data-id="element-97">
              <CTAButton className="w-full md:w-auto mb-3" onClick={scrollToPricing} data-id="element-98">
                DESCARGA MI PROTOCOLO 48h AHORA
              </CTAButton>
              <p className="text-sm text-warmgray flex items-center gap-2" data-id="element-99">
                <span className="w-2 h-2 rounded-full bg-sage" data-id="element-100"></span>
                Acceso instantáneo en PDF tras el pago.
              </p>

              {/* Download counter */}
              <div className="mt-5 flex items-center gap-3 bg-white/70 backdrop-blur-sm rounded-full py-2.5 px-5 shadow-sm border border-sage/10" data-id="element-101">
                <div className="flex -space-x-2" data-id="element-102">
                  {['C', 'V', 'A', 'G'].map((letter, i) => <div key={i} className="w-7 h-7 rounded-full border-2 border-white flex items-center justify-center text-xs font-bold text-white" style={{
                  backgroundColor: ['#C4704B', '#7C9A82', '#2D2A26', '#C4704B'][i],
                  zIndex: 4 - i
                }} data-id="element-103">
                      {letter}
                    </div>)}
                </div>
                <p className="text-sm text-charcoal" data-id="element-104">
                  <span className="font-bold" data-id="element-105">+1,247</span> mujeres ya lo
                  descargaron
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Right: Product image */}
          <FadeIn delay={0.2} direction="left" className="order-2 flex justify-center md:justify-end" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/cR1zRpMq57baWBofJSA7rc/ChatGPT_Image_Feb_28,_2026,_10_53_39_PM.png" alt="Protocolo Flash Anti-Inflamación 48H - Vista previa en tablet" className="w-full max-w-xs md:max-w-sm lg:max-w-md rounded-2xl shadow-2xl" data-id="element-107" />
          </FadeIn>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none opacity-30" data-id="element-108">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-terracotta/10 blur-3xl" data-id="element-109"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-sage/10 blur-3xl" data-id="element-110"></div>
      </div>
    </section>;
}